module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center",
    attrs: {
      "id": "ch00_fm02_alive"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('strong', [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTHER BOOKS BY STAN DAVIS")])])]), _vm._v(" "), _c('p', {
    staticClass: "centerm"
  }, [_c('em', [_vm._v("It’s Alive! The Convergence of"), _c('br'), _vm._v("Information, Biology and Business")]), _c('br'), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WITH CHRISTOPHER MEYER")])]), _vm._v(" "), _c('p', {
    staticClass: "centerm"
  }, [_c('em', [_vm._v("Lessons from the Future")])]), _vm._v(" "), _c('p', {
    staticClass: "centerm"
  }, [_c('em', [_vm._v("Future Wealth")]), _c('br'), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WITH CHRISTOPHER MEYER")])]), _vm._v(" "), _c('p', {
    staticClass: "centerm"
  }, [_c('em', [_vm._v("Blur")]), _c('br'), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WITH CHRISTOPHER MEYER")])]), _vm._v(" "), _c('p', {
    staticClass: "centerm"
  }, [_c('em', [_vm._v("The Monster Under the Bed")]), _c('br'), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WITH JIM BOTKIN")])]), _vm._v(" "), _c('p', {
    staticClass: "centerm"
  }, [_c('em', [_vm._v("2020 Vision")]), _c('br'), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WITH BILL DAVIDSON")])]), _vm._v(" "), _c('p', {
    staticClass: "centerm"
  }, [_c('em', [_vm._v("Future Perfect")])]), _vm._v(" "), _c('p', {
    staticClass: "centerm"
  }, [_c('em', [_vm._v("Managing Corporate Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "centerm"
  }, [_c('em', [_vm._v("Managing & Organizing Multinational Corporations")])]), _vm._v(" "), _c('p', {
    staticClass: "centerm"
  }, [_c('em', [_vm._v("Matrix")]), _c('br'), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WITH PAUL LAWRENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "centerm"
  }, [_c('em', [_vm._v("Workers & Managers in Latin America")]), _c('br'), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WITH LOUIS WOLF GOODMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "centerm"
  }, [_c('em', [_vm._v("Comparative Management")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b4aa783","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm02_alive.vue
// module id = 60
// module chunks = 0